import FormattedMessage from 'I18n/components/FormattedMessage';
import { MarketplaceIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { View } from 'foundations-components/transitional/components/View';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Paths } from '../../constants/paths';
import { useAppContext } from '../../context/AppContext';
import { StorefrontNav } from '../../navigation/components/StorefrontNav';
import { SearchBar } from '../../search-bar/components/SearchBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function HomepageHeader({
  navigation = true
}) {
  const appContext = useAppContext();
  return /*#__PURE__*/_jsxs(Flex, {
    blockSize: "140px",
    borderBlockStartWidth: appContext === 'public' ? '100' : '0',
    borderBlockStartStyle: "solid",
    borderBlockStartColor: "border-core-subtle",
    flexDirection: "column",
    justifyContent: "center",
    marginBlockStart: appContext === 'public' ? '300' : '0',
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      backgroundColor: "fill-surface-default",
      "data-test-id": "homepage-header",
      flexDirection: "row",
      insetBlockStart: "0",
      justifyContent: "space-between",
      position: "sticky",
      zIndex: "1",
      children: [/*#__PURE__*/_jsx(UIRouterLink, {
        to: Paths.HOME,
        use: "unstyled",
        children: /*#__PURE__*/_jsx(MediaObject, {
          align: "center",
          itemLeft: /*#__PURE__*/_jsx(IconHolder, {
            color: "fill-primary-default",
            icon: MarketplaceIcon,
            margin: "0",
            padding: "0",
            size: "600"
          }),
          spacing: "none",
          children: /*#__PURE__*/_jsx(Text, {
            as: "h1",
            typography: "heading-300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.headers.title"
            })
          })
        })
      }), /*#__PURE__*/_jsx(View, {
        inlineSize: "600px",
        marginInline: "300",
        children: /*#__PURE__*/_jsx(SearchBar, {})
      }), /*#__PURE__*/_jsx(Flex, {
        justifyContent: "end",
        children: appContext === 'app' ? /*#__PURE__*/_jsxs(Flex, {
          gap: "300",
          flexDirection: "row",
          children: [/*#__PURE__*/_jsx(Text, {
            color: "text-core-subtle",
            typography: "body-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.headers.app.manage"
            })
          }), /*#__PURE__*/_jsx(Text, {
            color: "text-core-subtle",
            typography: "body-100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.headers.app.build"
            })
          })]
        }) : /*#__PURE__*/_jsx(Text, {
          color: "text-core-subtle",
          typography: "body-100",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplaceStorefront.headers.public.build"
          })
        })
      })]
    }), navigation && /*#__PURE__*/_jsx(StorefrontNav, {})]
  });
}